import React from "react";
import { View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import DocumentEditor from "../../components/document/DocumentEditor";
import { DocumentType } from "../../__generated__/graphql";

const StoryComponent = ({ title, mimeType }: { title: string; mimeType: string }) => {
    return (
        <DocumentEditor
            document={{
                id: "annex-1",
                type: DocumentType.MissionAnnex,
                title,
                documentUrl: "https://example.com/annex",
            }}
            mimeType={mimeType}
            onClose={() => {}}
        />
    );
};

const meta = {
    title: "Components/Document editor",
    component: StoryComponent,
    args: {
        title: "planning-equipe.csv",
        mimeType: "text/csv",
    },
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const PreviewUnavailable: Story = {};
